<template>
  <v-menu bottom :close-on-click='true'>
    <template v-slot:activator='{ on }'>
      <v-btn class="flag-size" text v-on='on'>
        {{ currentLocale }}
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for='(locale, index) in availableLocales'
        :key='index'
        @click='changeLocale(locale.value)'
      >
        <v-list-item-title class="flag-size">
          {{ locale.label }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
  import Vue from 'vue'
  import moment from 'moment'

  export default {
    computed: {
      currentLocale() {
        sessionStorage.setItem('guestLocale', this.$i18n.locale)
        return this.$i18n.t('locales.' + this.$i18n.locale)
      },
      availableLocales() {
        return this.$i18n.availableLocales.filter((locale)=> (locale == "en" || locale == "it")).map((locale) => {
            return {
              label: this.$i18n.t('locales.' + locale),
              value: locale
            }
        })
      }
    },
    methods: {
      changeLocale(locale) {
        this.$i18n.locale = locale
        sessionStorage.setItem('guestLocale', locale)
        Vue.http.headers.common['Accept-Language'] = locale
        moment.locale(locale)
      }
    }
  }
</script>
<style lang='scss'>
div.flag-size, button.flag-size span {
  font-size: 20px;
  text-align: center;
}
</style>
